import { createSlice } from '@reduxjs/toolkit';
import { dispatch } from '../../store';
import { get, post, put } from '../../../inteceptor';
import moment from 'moment';

const initialState = {
  error: null,
  time: null,
  data: [],
  allData: [],
  addData: {},
  sorted: [],
};

const slice = createSlice({
  name: 'Assets',
  initialState,
  reducers: {
    // HAS ERROR
    hasError(state, action) {
      state.error = { message: action.payload, time: moment.now().toString() };
    },

    getAssetsSuccess(state, action) {
      state.data = action.payload.data;
    },
    getAllAssetsSuccess(state, action) {
      state.allData = action.payload.data;
    },

    addOrUpdateAssets(state, action) {
      state.addData = {
        data: action.payload.data,
        time: moment.now().toString(),
      };
    },

    clearAll(state) {
      state.addData = {};
      state.error = {};
    },

    onBackStep(state) {
      state.checkout.activeStep -= 1;
    },

    onNextStep(state) {
      state.checkout.activeStep += 1;
    },

    onGotoStep(state, action) {
      const goToStep = action.payload;
      state.checkout.activeStep = goToStep;
    },
  },
});

// Reducer
export default slice.reducer;

// Actions
export const { filterCategories } = slice.actions;

// ----------------------------------------------------------------------

export function getAllAssets() {
  return async () => {
    try {
      const response = await get(`allAssets`);
      if (response.status) {
        dispatch(slice.actions.getAllAssetsSuccess(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      console.log(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}
export function getAssets(locationId) {
  return async () => {
    try {
      const response = await get(`assets?locationId=${locationId}`);
      if (response.status) {
        dispatch(slice.actions.getAssetsSuccess(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      console.log(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function addAssets(body) {
  return async () => {
    try {
      const response = await post(`assets`, body);
      if (response.status) {
        dispatch(slice.actions.addOrUpdateAssets(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      console.log(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function updateAssets(body) {
  return async () => {
    try {
      const response = await put(`assets`, body);
      if (response.status) {
        dispatch(slice.actions.addOrUpdateAssets(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      console.log(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}
